<template>
  <div>
    <div class="row">
      <div class="col_12">
        <div class="card no_border">
          <div class="card-header" v-if="specialLectureCategory">
            <div class="card-title mr_10">
              {{ specialLectureCategory.name }}
              <span @click.prevent="openSlCategoryModal()">
                <i class="fas fa-pencil-alt cursor_pointer"></i>
              </span>
            </div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_2">
                <div class="form-group">
                  <label>{{ $t('common.grade') }}</label>
                  <div class="d_flex_start">
                    <div class="dropdown custom_dropdown mr_10">
                      <button class="btn">
                        <span>{{ filter2.grade }}</span>
                      </button>
                      <div class="dropdown_menu">
                        <ul>
                          <li>
                            <a
                              role="button"
                              @click="changeGradeFilter('all')"
                              >{{ $t('common.all') }}</a
                            >
                          </li>
                          <li
                            v-for="grade in grades"
                            :key="'grade ' + grade.id"
                          >
                            <a
                              role="button"
                              @click="changeGradeFilter(grade)"
                              >{{ grade.name }}</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col_2">
                <div class="form-group">
                  <label>{{ $t('sidebar.semesters.semesters') }}</label>
                  <div class="d_flex_start">
                    <div class="dropdown custom_dropdown mr_10">
                      <button class="btn">
                        <span>{{ filter2.semester }}</span>
                      </button>
                      <div class="dropdown_menu">
                        <ul>
                          <li>
                            <a
                              role="button"
                              @click="changeSemesterFilter('all')"
                              >{{ $t('common.all') }}</a
                            >
                          </li>
                          <li
                            v-for="semester in semesters"
                            :key="'semester ' + semester.id"
                          >
                            <a
                              role="button"
                              @click="changeSemesterFilter(semester)"
                              >{{ semester.name }}</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col_2">
                <div class="form-group">
                  <label>{{ $t('special_lecture.grade_group.title') }}</label>
                  <div class="d_flex_start">
                    <div class="dropdown custom_dropdown mr_10">
                      <button class="btn">
                        <span>{{ filter2.grade_group }}</span>
                      </button>
                      <div class="dropdown_menu">
                        <ul>
                          <li>
                            <a
                              role="button"
                              @click="changeGradeGroupFilter('all')"
                              >{{ $t('common.all') }}</a
                            >
                          </li>
                          <li
                            v-for="grade_group in grade_groups"
                            :key="'grade_group_' + grade_group.id"
                          >
                            <a
                              role="button"
                              @click="changeGradeGroupFilter(grade_group)"
                              >{{ grade_group.name }}</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col_6">
                <div class="form-group">
                  <label></label>
                  <div class="d_flex_end">
                    <div class="form_row_inline">
                      <input
                        type="text"
                        class="form_global"
                        :placeholder="$t('common.search')"
                        v-model="queryParams.search"
                      />
                    </div>
                    <div class="form_row_inline ml_10">
                      <div
                        class="btn btn_common_type_2 width_150p"
                        @click="searchQuery()"
                      >
                        {{ $t('common.search') }}
                      </div>
                      <div
                        class="btn btn_common_type_2 width_150p ml_10"
                        @click="resetAll()"
                      >
                        {{ $t('common.reset') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col_12">
                <div class="separator pl_0 pr_0">
                  <span></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col_12">
                <div class="d_flex_btwn pt_20 pb_20">
                  <div class="d_flex_start col_2 pl_0">
                    <div class="dropdown custom_dropdown mr_10">
                      <button class="btn">
                        <span>{{ filter.per_page }}</span>
                      </button>
                      <div class="dropdown_menu">
                        <ul>
                          <li @click="changeFilter(10)">
                            <a role="button">10</a>
                          </li>
                          <li @click="changeFilter(20)">
                            <a role="button">20</a>
                          </li>
                          <li @click="changeFilter(50)">
                            <a role="button">50</a>
                          </li>
                          <li @click="changeFilter(100)">
                            <a role="button">100</a>
                          </li>
                          <li @click="changeFilter(200)">
                            <a role="button">200</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <button class="btn btn_transparent ml_10 mr_10">
                      {{ $t('common.download_contents') }}
                    </button>
                    <button class="btn btn_transparent">
                      {{ $t('common.upload_contents') }}
                    </button>
                  </div>
                  <div class="d_flex_end col_6 pr_0">
                    <router-link
                      :to="{ name: 'special_lecture_create' }"
                      class="add_new cursor_pointer btn btn_transparent"
                      >+
                      {{
                        $t('sidebar.holidayLecture.create_new_lecture')
                      }}</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <table-component
              :columns="columns"
              :rows="special_lectures"
              :pagination="pagination"
              @sorting="sorting"
              :sortable="sortable"
              @pageChanged="pageChanged"
            >
              <template #id="{ row }">
                <div class="form_checkbox">
                  <input
                    type="checkbox"
                    :id="'course' + row.id"
                    :checked="checkedLecture.includes(row.id)"
                    name="checkbox"
                  />
                  <label
                    :for="'course' + row.id"
                    @click="checkedSingleLecture(row.id)"
                  ></label>
                </div>
              </template>
              <template #sort="{ row }">
                <div @keyup.enter="updateRecordOrder(row)">
                  <input
                    type="text"
                    min="0"
                    :value="row.sort"
                    class="form_global width_50p"
                    @input="onInputChangeOrder($event, row)"
                  />
                  <button
                    class="btn btn_success"
                    style="padding: 5px 10px"
                    @click="updateRecordOrder(row)"
                  >
                    <i class="fas fa-check"></i>
                  </button>
                </div>
              </template>
              <template #video_convert_status="{ row }">
                <span
                  v-if="row.lectureVideos && row.lectureVideos.length > 0"
                  >{{ row.video_convert_status }}</span
                >
              </template>
              <template #special_exams="{ row }">
                <div class="">
                  <button
                    class="btn btn_yellow ml_5"
                    @click.prevent="showAllVideo(row.lectureVideos)"
                    v-if="row.lectureVideos && row.lectureVideos.length > 0"
                  >
                    {{ $t('special_lecture.video') }}
                  </button>
                  <button
                    class="btn btn_yellow ml_5"
                    @click.prevent="showLectureImage(row.images)"
                    v-else-if="row.images"
                  >
                    {{ $t('special_lecture.image') }}
                  </button>
                  <template
                    v-for="(exam, index) in row.special_exams"
                    :key="'special_exams' + index"
                  >
                    <button
                      class="btn btn_yellow ml_5 mr_5"
                      @click.prevent="showQuestion(exam)"
                    >
                      {{ $t('sidebar.lectureCommon.exam') }}
                    </button>
                  </template>
                  <button
                    class="btn btn_yellow ml_5"
                    @click.prevent="showLectureAttachments(row.attachments)"
                    v-if="row.attachments && row.attachments.length > 0"
                  >
                    {{ $t('special_lecture.download') }}
                  </button>
                </div>
              </template>
              <template #action="{ row }">
                <div class="d_flex_center table_action_btn">
                  <button
                    v-if="row.status == 1"
                    class="btn btn_success status_update"
                    title="Active"
                    @click.prevent="deactivate(row)"
                  >
                    <i class="fas fa-check"></i>
                  </button>
                  <button
                    v-else
                    class="btn btn_warning status_update"
                    title="Inactive"
                    @click.prevent="activate(row)"
                  >
                    <i class="fa fa-window-close"></i>
                  </button>
                  <router-link
                    :to="{
                      name: 'special_lecture_edit',
                      params: {
                        id: row.special_lecture_category_id,
                        lecture_id: row.id,
                      },
                    }"
                    :title="$t('common.edit')"
                    class="btn btn_blue ml_10"
                  >
                    <img
                      :src="`${baseUrl}assets/media/images/icon/8.png`"
                      alt=""
                    />
                  </router-link>
                  <button
                    class="btn btn_danger ml_10"
                    :title="$t('common.delete')"
                    @click.prevent="deleteRecord(row)"
                  >
                    <img
                      :src="`${baseUrl}assets/media/images/icon/9.png`"
                      alt=""
                    />
                  </button>
                </div>
              </template>
            </table-component>
          </div>
        </div>
      </div>
    </div>
    <video-modal
      v-if="videoModalShow"
      :showVideoModal="videoModalShow"
      :video="videoSmilFile"
      @closeModal="closeModal()"
    ></video-modal>
    <all-video-modal
      v-if="allVideoModalShow"
      :allVideoModalShow="allVideoModalShow"
      :videos="lectureAllVideos"
      @closeModal="closeModal()"
    ></all-video-modal>
    <question-modal
      v-if="questionModalShow"
      :showQuestionModal="questionModalShow"
      :questionExam="questionExam"
      @closeModal="closeModal()"
    />
    <SlCategoryModal
      v-if="showSlCategoryModal"
      :showSlCategoryModal="showSlCategoryModal"
      :specialLectureCategory="specialLectureCategory"
      @closeModal="closeSlCategoryModal"
    />
    <LectureImageModal
      v-if="showImageModal"
      :showImageModal="showImageModal"
      :lectureImage="lectureImage"
      @closeModal="closeLectureImageModal"
    />
    <AttachmentModal
      v-if="showAttachmentModal"
      :showAttachmentModal="showAttachmentModal"
      :lectureAttachments="lectureAttachments"
      @closeModal="closeLectureAttachmentModal"
    />
  </div>
</template>

<script>
import TableComponent from '@/components/shared/TableComponent';
import VideoModal from '../components/VideoModal.vue';
import AllVideoModal from '../components/AllVideoModal.vue';
import LectureImageModal from '../components/LectureImageModal.vue';
import AttachmentModal from '../components/AttachmentModal.vue';
import QuestionModal from '@/components/QuestionModal.vue';
import SlCategoryModal from '../../../components/shared/SlCategoryModal.vue';
export default {
  name: 'special-lecture-list',
  components: {
    TableComponent,
    VideoModal,
    QuestionModal,
    AllVideoModal,
    SlCategoryModal,
    LectureImageModal,
    AttachmentModal,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      special_lectures: [],
      grades: [],
      semesters: [],
      grade_groups: [],
      checkedLecture: [],
      filter: {
        grade: '',
        semester: '',
        grade_group: '',
        per_page: 20,
      },
      filter2: {
        grade: this.$t('common.all'),
        semester: this.$t('common.all'),
        grade_group: this.$t('common.all'),
        per_page: 20,
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'learning_goal',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20,
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc',
      },
      columns: [
        {
          label: '',
          field: 'id',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('special_lecture.exposure_order'),
          field: 'sort',
          sortable: true,
          slot: true,
        },
        {
          label: this.$t('common.subject'),
          field: 'subject.name',
          sortable: false,
        },
        {
          label: this.$t('common.grade'),
          field: 'grade.name',
          sortable: false,
        },
        {
          label: this.$t('common.semester'),
          field: 'semester.name',
          sortable: false,
        },
        {
          label: this.$t('special_lecture.grade_group.title'),
          field: 'grade_group.name',
          sortable: false,
        },
        {
          label: this.$t('common.created_at'),
          field: 'created_at',
          sortable: true,
        },
        {
          label: this.$t('sidebar.lectureCommon.convert_status'),
          field: 'video_convert_status',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('special_lecture.learning_content'),
          field: 'special_exams',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('common.action'),
          field: 'action',
          sortable: false,
          slot: true,
        },
      ],
      videoSmilFile: null,
      videoModalShow: false,
      allVideoModalShow: false,
      lectureAllVideos: [],
      questionModalShow: false,
      questionExam: null,
      specialLectureCategory: null,
      showSlCategoryModal: false,
      showImageModal: false,
      lectureImage: null,
      showAttachmentModal: false,
      lectureAttachments: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        // this.setQueryData(this.getAllQueryParams())
        this.loadData();
      }
    },
  },
  created() {
    const query = this.getAllQueryParams();
    if (query.page) {
      this.setQueryData(query);
    }

    if (this.$route.params.id) {
      this.loadData();
    }

    this.axios
      .get('/grades')
      .then((response) => (this.grades = response.data.data));
    this.axios
      .get('/semesters')
      .then((response) => (this.semesters = response.data.data));
    this.axios
      .get('/grade-groups')
      .then((response) => (this.grade_groups = response.data.data));
  },
  methods: {
    openSlCategoryModal() {
      this.showSlCategoryModal = true;
    },
    closeSlCategoryModal() {
      this.axios
        .get('/special-lecture-categories/' + this.$route.params.id)
        .then((response) => (this.specialLectureCategory = response.data.data));
      this.showSlCategoryModal = false;
    },
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page,
      };

      this.filter = {
        grade: query.grade,
        semester: query.semester,
        grade_group: query.grade_group,
        per_page: query.per_page,
      };

      this.sortable = {
        order: query.sort,
        sort: query.sort_order,
      };
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc',
      };

      this.filter = {
        grade: '',
        semester: '',
        grade_group: '',
        per_page: 20,
      };

      this.filter2 = {
        grade: this.$t('common.all'),
        semester: this.$t('common.all'),
        grade_group: this.$t('common.all'),
      };

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'learning_goal',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20,
      };

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({ column, order }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute();
    },
    changeGradeFilter(grade) {
      if (grade == 'all') {
        this.filter.grade = '';
        this.filter2.grade = this.$t('common.all');
      } else {
        this.filter.grade = grade.id;
        this.filter2.grade = grade.name;
      }
      this.changeRoute();
    },
    changeSemesterFilter(semester) {
      if (semester == 'all') {
        this.filter.semester = '';
        this.filter2.semester = this.$t('common.all');
      } else {
        this.filter.semester = semester.id;
        this.filter2.semester = semester.name;
      }
      this.changeRoute();
    },
    changeGradeGroupFilter(grade_group) {
      if (grade_group == 'all') {
        this.filter.grade_group = '';
        this.filter2.grade_group = this.$t('common.all');
      } else {
        this.filter.grade_group = grade_group.id;
        this.filter2.grade_group = grade_group.name;
      }
      this.changeRoute();
    },
    changeFilter(per_page) {
      this.filter.per_page = per_page;
      this.changeRoute();
    },
    changeRoute() {
      this.$router.push({
        name: this.$route.name,
        query: { ...this.queryParams, ...this.filter },
      });
    },
    loadData() {
      this.axios
        .get('/special-lecture-categories/' + this.$route.params.id)
        .then((response) => {
          this.specialLectureCategory = response.data.data;
        });

      this.queryParams.special_lecture_category_id = this.$route.params.id;
      this.axios
        .get('/special-lectures', {
          params: { ...this.queryParams, ...this.filter },
        })
        .then((response) => {
          this.special_lectures = response.data.data;
          this.pagination = response.data.meta;
        });
    },
    checkedSingleLecture(id) {
      let index = window._.findIndex(
        this.checkedLecture,
        (checkedLectureId) => checkedLectureId == id
      );
      if (index > -1) this.checkedLecture.splice(index, 1);
      else this.checkedLecture.push(id);
    },
    showAllVideo(videos) {
      this.allVideoModalShow = true;
      this.lectureAllVideos = videos;
    },
    showExplanationVideo(smilFile) {
      this.videoModalShow = true;
      this.videoSmilFile = smilFile;
    },
    showQuestion(exam) {
      this.questionExam = exam;
      this.questionModalShow = true;
    },
    closeModal() {
      this.questionExam = null;
      this.videoModalShow = false;
      this.questionModalShow = false;
      this.allVideoModalShow = false;
    },
    showLectureImage(image) {
      this.lectureImage = image;
      this.showImageModal = true;
    },
    closeLectureImageModal() {
      this.lectureImage = null;
      this.showImageModal = false;
    },
    showLectureAttachments(attachments) {
      this.lectureAttachments = attachments;
      this.showAttachmentModal = true;
    },
    closeLectureAttachmentModal() {
      this.lectureAttachments = [];
      this.showAttachmentModal = false;
    },
    activate(lecture) {
      let lecture_id = lecture.id;
      let status = lecture.status;
      this.$swal({
        title: this.$t('common.active_confirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yes_activate'),
        cancelButtonText: this.$t('common.no_cancel'),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/update-special-lecture-status/', {
              id: lecture_id,
              status: status,
            })
            .then(() => {
              this.loadData();
              this.$swal.fire(
                this.$t('common.activated'),
                this.$t('common.activated_success'),
                'success'
              );
            });
        }
      });
    },
    deactivate(lecture) {
      let lecture_id = lecture.id;
      let status = lecture.status;
      this.$swal({
        title: this.$t('common.deactivate_confirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yes_deactivate'),
        cancelButtonText: this.$t('common.no_cancel'),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/update-special-lecture-status/', {
              id: lecture_id,
              status: status,
            })
            .then(() => {
              this.loadData();
              this.$swal.fire(
                this.$t('common.deactivated'),
                this.$t('common.deactivated_success'),
                'success'
              );
            });
        }
      });
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/special-lectures/' + row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.deleted'),
              this.$t('common.deleteMessage'),
              'success'
            );
          });
        }
      });
    },
    onInputChangeOrder(event, row) {
      const value = parseInt(event.target.value);
      row.sort = isNaN(value) || value < 0 ? 0 : value;
    },
    updateRecordOrder(row) {
      this.axios
        .post(`/update-special-lecture-sort-order/${row.id}`, {
          sort: row.sort,
        })
        .then(({ data }) => {
          if (data.success) {
            this.showSuccessMsg(data.message);
          } else {
            this.showFailMsg(data.message);
          }
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            this.showFailMsg(response.data.message);
          }
        });
    },
  },
};
</script>
